import React from 'react';
import { Box, Container } from '@mui/material';
import News from './News';
import NewsletterSignup from './NewsletterSignup';

/**
 * Composite section for News + Newsletter.
 * - News renders first.
 * - Newsletter renders beneath it on all screen sizes.
 * - This wrapper intentionally does NOT render a heading to avoid duplicates.
 */
export default function NewsletterAndNews() {
    return (
        <Box component="section" sx={{ backgroundColor: 'background.default', py: { xs: 5, md: 7 } }}>
            <Container maxWidth="lg">
                {/* NEWS (includes its own single heading) */}
                <Box sx={{ mb: { xs: 4, md: 6 } }}>
                    <News />
                </Box>

                {/* NEWSLETTER SIGNUP */}
                <NewsletterSignup />
            </Container>
        </Box>
    );
}
